import React from 'react'
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { Box,Grid } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import MainLayout from '../components/common/layout/MainLayout'
import ReportLeftNavigation from '../components/performance/navigation/reportLeftNavigation';
import ReportMobileNavigation from '../components/performance/navigation/reportMobileNavigation';
import UsageReport from '../components/performance/usageReport';
import { DataContext, DataDispatchContext } from '../contexts/data/dataContext'
import custom from '../styles/mui/szVariables.json'
import { clickAnalyticsReport } from '../components/common/util/util'

export default function Performance() {
  const navigate = useNavigate()
  const data = useContext(DataContext)
  const dispatch: any = useContext(DataDispatchContext)  
  const tablet = useMediaQuery('(max-width:1100px)');

  const reports: any = {
    home: <UsageReport id="home" title="Home usage" />,
    solar: <UsageReport  id="solar" title="Solar production" />,
    battery: <UsageReport  id="battery" title="Battery performance" />,
    grid: <UsageReport id="grid" title="Grid usage" />,
  }

  useEffect(() => {
    window.scrollTo(0,0)
    if(data?.rightPanel?.key!=='help') {
      dispatch({
        type: 'setRightPanel',
        rightPanel: null
      })
    }
    if(data?.customer?.hasUsageData===false) {
      navigate('/')
    }
  },[
    dispatch, 
    navigate, 
    data?.rightPanel, 
    data?.customer?.hasUsageData
  ])

  return (
    <MainLayout>
      <Box display="flex" 
            flexDirection="row" 
            id="reportContent"
            justifyContent="flex-start"
            maxWidth={"100%"}
          >
          <Grid container direction={"column"} 
              justifyContent={"center"}>
              <Grid item maxWidth="100%" 
                borderBottom={custom.border}
                display={{ 
                  xs: 'flex', 
                  sm: data?.rightPanel?'flex':'none', 
                  md: (data?.rightPanel && tablet)?'flex':'none', 
                  lg: 'none'
                }}
                >
                <ReportMobileNavigation clickAnalytics={clickAnalyticsReport}/>
              </Grid>
              <Grid item maxWidth="100%" >
                <Grid container direction="row" 
                    justifyContent={"center"} maxWidth="100%">
                  <Grid item 
                      width={{
                        xs: 0,
                        sm: "234px",
                        md: (data.rightPanel && tablet)?0:'234px', 
                        lg: "234px",
                      }}
                      display={{ 
                        xs: 'none', 
                        sm: data?.rightPanel?'none':'flex', 
                        md: (data?.rightPanel && tablet)?'none':'flex', 
                        lg: 'flex'
                      }}>
                      <ReportLeftNavigation clickAnalytics={clickAnalyticsReport}/>
                  </Grid>
                  <Grid item xs>
                    {reports[data?.reportSelected]}
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
      </Box>
    </MainLayout>
  )
}
